var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIEyes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 33.76 37.576",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shared-vision",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M160.734,197.468a.734.734,0,1,0-.734-.734A.734.734,0,0,0,160.734,197.468Zm0,0",
    transform: "translate(-148.257 -181.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M220.734,6.312a.734.734,0,0,0,.734-.734V.734a.734.734,0,0,0-1.468,0V5.578A.734.734,0,0,0,220.734,6.312Zm0,0",
    transform: "translate(-203.853)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M220,426.734v4.844a.734.734,0,0,0,1.468,0v-4.844a.734.734,0,1,0-1.468,0Zm0,0",
    transform: "translate(-203.853 -394.736)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M33.618,80.656a.734.734,0,0,0,1.038-1.038L31.542,76.5A.734.734,0,1,0,30.5,77.542Zm0,0",
    transform: "translate(-28.065 -70.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M367.5,383.5a.734.734,0,0,0,0,1.038l3.114,3.114a.734.734,0,0,0,1.038-1.038l-3.114-3.114A.734.734,0,0,0,367.5,383.5Zm0,0",
    transform: "translate(-340.325 -355.151)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M368.534,80.656l3.114-3.114a.734.734,0,1,0-1.038-1.038L367.5,79.618a.734.734,0,0,0,1.038,1.038Zm0,0",
    transform: "translate(-340.326 -70.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M33.618,383.5,30.5,386.61a.734.734,0,0,0,1.038,1.038l3.114-3.114a.734.734,0,0,0-1.038-1.038Zm0,0",
    transform: "translate(-28.065 -355.152)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M4.686,131.606a19.033,19.033,0,0,0,12.195,4.944,19.033,19.033,0,0,0,12.195-4.944,26.639,26.639,0,0,0,4.56-4.921.734.734,0,0,0,0-.819,26.65,26.65,0,0,0-4.56-4.921A19.032,19.032,0,0,0,16.881,116a19.033,19.033,0,0,0-12.195,4.944,26.666,26.666,0,0,0-4.56,4.921.734.734,0,0,0,0,.819,26.663,26.663,0,0,0,4.56,4.921Zm.948-9.541c2.48-2.1,6.444-4.6,11.247-4.6s8.742,2.486,11.216,4.571a26.749,26.749,0,0,1,4.025,4.237,26.67,26.67,0,0,1-3.994,4.209c-2.48,2.1-6.444,4.6-11.247,4.6S8.138,132.6,5.665,130.511a26.736,26.736,0,0,1-4.025-4.237,26.635,26.635,0,0,1,3.993-4.21Zm0,0",
    transform: "translate(0 -107.487)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M146.605,179.21a6.605,6.605,0,1,0-2.364-12.775.736.736,0,1,0,.6,1.342,5.138,5.138,0,1,1-3.376,4.827,5.341,5.341,0,0,1,.085-.937.734.734,0,0,0-1.443-.27,6.612,6.612,0,0,0,6.5,7.812Zm0,0",
    transform: "translate(-129.725 -153.817)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M195.871,218.936a2.936,2.936,0,1,0-2.936,2.936A2.939,2.939,0,0,0,195.871,218.936Zm-4.4,0a1.468,1.468,0,1,1,1.468,1.468A1.47,1.47,0,0,1,191.468,218.936Zm0,0",
    transform: "translate(-176.055 -200.148)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIEyes);
export default __webpack_public_path__ + "static/media/i-eyes.5330156145276ed739db1ae7a5a9913f.svg";
export { ForwardRef as ReactComponent };